import { useContext } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  VStack,
  Heading,
  FormControl,
  FormLabel,
  useColorModeValue,
  Text,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import {
  CustomReactSelect,
  formatOptionLabelFilterPassTemplate,
} from '../common/CustomReactSelect';
import PassDownloadTemplateContext from '../../store/client/PassDownloadTemplateContext';

const AddLanguageModal = ({
  isOpen,
  onClose,
  setEditingLang,
  selectedLanguage,
  setSelectedLanguage,
  languageOptions,
}) => {
  const { handleSubmit, formState } = useForm();
  const { isSubmitting } = formState;
  const passDownloadCtx = useContext(PassDownloadTemplateContext);

  const modeBoxBg = useColorModeValue('white', 'secondaryDark');
  const modeTextBg = useColorModeValue('white', 'primaryDark06');
  const modeLabelBg = useColorModeValue('white', 'primaryDark03');
  const modeOffset = useColorModeValue('0', '16px !important');

  const onSubmit = async () => {
    if (!selectedLanguage) return;
    passDownloadCtx.updateTranslations(selectedLanguage.value, 'name', '');
    setEditingLang(selectedLanguage.value);
    onClose();
  };

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      closeOnOverlayClick={false}
      size="lg"
    >
      <ModalOverlay />
      <ModalContent bg={modeBoxBg} p="10px" borderRadius="15px">
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader
            bg={modeTextBg}
            pb={modeOffset}
            borderRadius="15px 15px 0 0"
          >
            <Heading>Add new language</Heading>
          </ModalHeader>
          <ModalBody bg={modeLabelBg}>
            <VStack my="20px">
              <FormControl>
                <FormLabel m={0}> Select language</FormLabel>
                <CustomReactSelect
                  options={languageOptions}
                  placeholder="Select language"
                  formatOptionLabel={formatOptionLabelFilterPassTemplate}
                  onChange={(language) => {
                    setSelectedLanguage(
                      language
                        ? { label: language.label, value: language.value }
                        : null
                    );
                  }}
                  value={selectedLanguage}
                  id="passTemplateFilter"
                  passTemplate
                  aria-label="Select language"
                />
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter display="flex" justifyContent="flex-end" gap={2}>
            <Button variant="secondary" size="sm" onClick={onClose}>
              <Text>Cancel</Text>
            </Button>
            <Button
              type="submit"
              alt="OK"
              fontSize="14px"
              h="36px"
              width={{ base: 'full', sm: 'auto' }}
              isLoading={isSubmitting}
              isDisabled={!selectedLanguage}
            >
              Add
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};
export default AddLanguageModal;
